import './scss/ferzui.scss';
import { FerzUI } from './core/FerzUI';
import { BaseComponent } from './core/BaseComponent';
import { ThemeManager } from './services/ThemeManager';
import { SkeletonService } from './services/SkeletonService';
import { Modal } from './components/Modal';
import { Dropdown } from './components/Dropdown';
import { Toast } from './components/Toast';
import { Tooltip } from './components/Tooltip';
import { AdvancedTable } from './components/AdvancedTable';
import { Tabs } from './components/Tabs';
import { Accordion } from './components/Accordion';
import { CommandPalette } from './components/CommandPalette';
import { DatePicker } from './components/DatePicker';
import { FileUpload } from './components/FileUpload';
import { AdvancedSelect } from './components/AdvancedSelect';

// Create the global instance
const fz = new FerzUI();

// Initialize Services
const theme = new ThemeManager(fz);
const skeleton = new SkeletonService();

// Register all components
fz.registerComponent('modal', Modal);
fz.registerComponent('dropdown', Dropdown);
fz.registerComponent('toast', Toast);
fz.registerComponent('tooltip', Tooltip);
fz.registerComponent('advanced-table', AdvancedTable);
fz.registerComponent('tabs', Tabs);
fz.registerComponent('accordion', Accordion);
fz.registerComponent('command-palette', CommandPalette);
fz.registerComponent('date-picker', DatePicker);
fz.registerComponent('file-upload', FileUpload);
fz.registerComponent('advanced-select', AdvancedSelect);

// Attach services to the instance for easy access
(fz as any).theme = theme;
(fz as any).skeleton = skeleton;

// Export everything
export {
  FerzUI,
  BaseComponent,
  ThemeManager,
  SkeletonService,
  Modal,
  Dropdown,
  Toast,
  Tooltip,
  AdvancedTable,
  Tabs,
  Accordion,
  CommandPalette,
  DatePicker,
  FileUpload,
  AdvancedSelect,
  fz // Default instance
};

// Global access for non-module systems
if (typeof window !== 'undefined') {
  (window as any).FerzUI = FerzUI;
  (window as any).fz = fz;
}
